import script from "./AdminAddCounselling.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAddCounselling.vue?vue&type=script&setup=true&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./AdminAddCounselling.vue?vue&type=style&index=1&id=d8dd785e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8dd785e"]])

export default __exports__